import { useLang } from "../../context/LangContext";

export const StockBadge = ({ stock, testid }) => {
  const { t } = useLang();
  if (stock <= 0) return <span data-testid={testid} className="badge-pill bg-[#120E1F]/5 text-[#707783]">{t("sold_out")}</span>;
  if (stock <= 3) return <span data-testid={testid} className="badge-pill bg-red-50 text-red-700"><i className="dot bg-red-500 animate-pulse" />{t("low_stock", { n: stock })}</span>;
  return <span data-testid={testid} className="badge-pill bg-emerald-50 text-emerald-700"><i className="dot bg-emerald-500" />{t("in_stock")}</span>;
};
